import { ElementsSDK } from '@yiluhub/ui-sdk-react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { paramConverters, yiluTracking } from 'utils';

import routes from 'router/routes';

import { LoungeSearchFormProps } from '../../../components';
import { LoungeSearchResultsPageQueryParams } from '../../../utils/query-params';

const useLoungeSearchFormProps = (
  loungeSearchResultsPageQueryParams: LoungeSearchResultsPageQueryParams,
  loungeAirports: ElementsSDK.FilteredAirportDetails[],
  popularAirportsIATAs?: string[],
) => {
  const navigate = useNavigate();
  return useMemo(() => {
    const { entryDate, airportDetails, fcle, maxTravellersCount, adults, children, infants } =
      loungeSearchResultsPageQueryParams;

    const _props: LoungeSearchFormProps = {
      searchInput: {
        entryDate,
        airport: airportDetails,
        adults,
        children,
        infants,
      },
      onSubmit(data) {
        const nextLoungeSearchResultsPageQueryParams = {
          adults: data.adults,
          children: data.children,
          infants: data.infants,
          entryDate: data.entryDate,
          airportDetails: data.airport,
        };

        navigate({
          pathname: routes.LOUNGES_SEARCH_RESULTS,
          search: paramConverters.getURLSearchQuery(nextLoungeSearchResultsPageQueryParams),
        });

        yiluTracking.sendGAEvent({
          event: 'srp_cta_clicked',
          category: 'lounge-srp',
          label: 'lounge_srp_cta_clicked',
        });
      },
      onError(error: Error) {
        throw error;
      },
      popularAirportsIATAs: popularAirportsIATAs,
      loungeAirports,
      maxTravellersCount: fcle && maxTravellersCount ? maxTravellersCount : undefined,
    };
    return _props;
  }, [loungeSearchResultsPageQueryParams, navigate, loungeAirports, popularAirportsIATAs]);
};

export default useLoungeSearchFormProps;
